import { Tab, Tabs } from '@material-ui/core';
import { Link, useParams } from 'react-router-dom';
import React from 'react';

export const ACTIVE_CLIENT_SIDEBAR_TAB_NAMES = {
    client: 0,
    paymentmethods: 1,
    documents: 2,
    users: 3,
    usergroups: 4,
    discountpackages: 5,
    vendorpriceitems: 6,
    clientpriceitems: 7,
    clientactivities: 8,
    activityimport: 9
};

export default function ClientEditSidebar({ activeTab }) {
    const { clientId } = useParams();
    return (
        <Tabs orientation="vertical" variant="scrollable" value={activeTab}>
            <Tab label="Client" component={Link} to={`/admin/client/${clientId}/`} />
            <Tab
                label="Payment methods"
                component={Link}
                to={`/admin/client/${clientId}/paymentmethods/`}
            />
            <Tab label="Documents" component={Link} to={`/admin/client/${clientId}/documents/`} />
            <Tab label="Users" component={Link} to={`/admin/client/${clientId}/users/`} />
            <Tab label="UserGroups" component={Link} to={`/admin/client/${clientId}/usergroups/`} />
            <Tab
                label="Discount Packages"
                component={Link}
                to={`/admin/client/${clientId}/discountpackages/`}
            />
            <Tab
                label="Vendor Price items"
                component={Link}
                to={`/admin/client/${clientId}/vendorpriceitems/`}
            />
            <Tab
                label="Client Price items"
                component={Link}
                to={`/admin/client/${clientId}/clientpriceitems/`}
            />
            <Tab
                label="Activities"
                component={Link}
                to={`/admin/client/${clientId}/clientactivities/`}
            />
            {activeTab === ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.activityimport && (
                <Tab
                    label="Activity Import"
                    component={Link}
                    to={`/admin/client/${clientId}/activity_import/`}
                />
            )}
        </Tabs>
    );
}
